<template>
  <div>
    <div class="row w-100 ml-0 mr-0 investorPublicNavLayout">
      <div class="d-flex m-auto investorPublicFiifiLayout">fiifi</div>
    </div>
    <div
      v-if="isShowInfo"
      class="row w-100 ml-0 mr-0"
      style="margin: 65px 0px 65px 0px"
    >
      <div class="col-3"></div>
      <div class="col-6">
        <div class="investorPublicCardLayout">
          <div style="padding: 30px">
            <div class="investorPublicTitle" style="margin-bottom: 30px">
              Below you can select which investors get KPI updates from you via
              fiifi, at any time you can add and delete investors from the list.
              <br />
              <br />
              We will send you an email once a month for you to simply fill out
              your KPI’s, we automatically update the investors listed below.
            </div>
            <!-- <div style="padding-right: 20px"> -->
            <div
              class="d-flex justify-content-between w-100"
              v-for="(item, index) in investorsList"
              :key="index"
              :style="
                item.canDelete
                  ? 'margin-bottom: 20px'
                  : 'margin-bottom: 20px;padding-right: 20px'
              "
            >
              <div class="d-flex">
                <div class="d-flex my-auto">
                  <input
                    type="checkbox"
                    :id="item.id"
                    class="regular-checkbox"
                    :style="
                      validateEmail(item.email)
                        ? 'cursor: pointer'
                        : 'background-color: #e0e0e0'
                    "
                    :disabled="!validateEmail(item.email)"
                    @change="checkBoxChangeEvent(item)"
                  />
                </div>
                <div
                  class="investorsList d-flex my-auto"
                  style="margin-left: 10px"
                  v-if="!item.canDelete"
                >
                  {{ item.name }}
                </div>
                <div v-else style="margin-left: 10px">
                  <input
                    type="text"
                    v-model="item.name"
                    placeholder="Enter Name"
                    class="form-control investorsList"
                  />
                </div>
              </div>
              <div class="d-flex">
                <div>
                  <input
                    type="text"
                    v-model="item.email"
                    placeholder="Enter Email"
                    class="form-control investorsList"
                    style="color: #593bfd"
                    @keyup="checkEmail(item, index)"
                  />
                </div>
                <div
                  class="d-flex my-auto"
                  style="padding-left: 8px; cursor: pointer"
                  v-if="item.canDelete"
                  @click="deleteInvestor(item, index)"
                >
                  <img src="static/img/delete-icon.svg" class="" />
                </div>
              </div>
            </div>
            <div>
              <button class="newTask" @click="addInvestor">
                <i class="fa fa-plus" aria-hidden="true"></i>
                Add
              </button>
            </div>
            <div style="margin-top: 30px">
              <div
                class="col-xl edit-company-action-button-row"
                style="padding: 0px"
              >
                <div>
                  Your privacy is important to us, we only share this data with
                  those on the list above. fiifi is protected by the most up to
                  date security,
                  <a href="https://fiifi.co/terms-of-service/" target="_blank">terms of service</a> and
                  <a href="https://fiifi.co/privacy-policy/" target="_blank">privacy policy </a> guidelines.
                </div>

                <button
                  type="button"
                  :disabled="!showSubmitButton"
                  class="todo-form-submit-button btn btn-primary"
                  @click="handleSubmit"
                >
                  Submit
                  <!-- <i class="nc-icon nc-refresh-02 spinner" v-if="showSpinner"></i> -->
                  <b-spinner
                    v-if="showSpinner"
                    style="float: right"
                    small
                    label="Loading..."
                  ></b-spinner>
                </button>
              </div>
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
      <div class="col-3"></div>
    </div>

    <div v-if="isShowThankYou" style="text-align: center; margin: 150px">
      Thank You for the update!
    </div>
  </div>
</template>
<script>
import api from "../../../axios_api";
export default {
  name: "investorsPublic",
  data() {
    return {
      investorsList: [],
      showSubmitButton: false,
      checkedData: [],
      showSpinner: false,
      isShowInfo: true,
      isShowThankYou: false,
    };
  },
  methods: {
    getInvestors() {
      const self = this;
      api
        .get(`/portfolio/investors/${this.$route.query.p}`, {})
        .then((data) => {
          if (data.data.encrypt.success) {
            self.investorsList = [
              ...data.data.encrypt.success.fiifiAccounts,
              ...data.data.encrypt.success.nonFiifiAccounts,
            ];

            self.investorsList.map((item, index) => {
              if (item.portfolio_item) {
                item.name =
                  item.name ||
                  (item.firstName
                    ? item.firstName +
                      " " +
                      (item.lastName ? item.lastName : "")
                    : "");
                item.id = item.portfolio_item;
              } else {
                item.id = `${item.name}-${index}`;
              }
              item.canDelete = false;
              if (item && !item.hasOwnProperty("email")) {
                item.email = "-";
              }
            });
          }
        })
        .catch((error) => {
          console.log("error in getInvestors", error);
        });
    },
    checkBoxChangeEvent(data) {
      this.showSubmitButton = false;
      if (document.getElementById(data.id).checked) {
        this.checkedData.push(data);
        this.showSubmitButton = true;
      } else {
        // this.checkedData.hasOwnProperty(id) ? delete this.checkedData[id] : "";
        let index = this.checkedData.findIndex((item) => {
          return item.id == data.id;
        });
        if (index >= 0) {
          this.checkedData.splice(index, 1);
          this.showSubmitButton = true;
        }
      }
      if (this.checkedData.length == 0) {
        this.showSubmitButton = false;
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    checkEmail(item, index) {
      if (this.validateEmail(item.email)) {
        if (document.getElementById(item.id)) {
          document.getElementById(item.id).disabled = false;
          document.getElementById(item.id).style = "";
          document.getElementById(item.id).style = "cursor:pointer";
        }
      } else {
        if (document.getElementById(item.id)) {
          document.getElementById(item.id).disabled = true;
          document.getElementById(item.id).style = "";
          document.getElementById(item.id).style = "background-color: #e0e0e0";
        }
      }
    },
    addInvestor() {
      let index =
        this.investorsList && this.investorsList.length > 0
          ? this.investorsList.length
          : 1;
      let obj = {
        name: "",
        email: "-",
        canDelete: true,
      };
      obj.id = `${new Date().getTime()}-${index}`;
      this.investorsList.push(obj);
    },
    deleteInvestor(item, index) {
      let checkedIndex = this.checkedData.findIndex((checkedItem) => {
        if (checkedItem.id == item.id) {
          return checkedItem;
        }
      });
      if (checkedIndex >= 0) {
        if (
          document.getElementById(this.checkedData[checkedIndex].id).checked
        ) {
          document.getElementById(
            this.checkedData[checkedIndex].id
          ).checked = false;
        }
        this.checkedData.splice(checkedIndex, 1);
        if (this.checkedData.length == 0) {
          this.showSubmitButton = false;
        }
      }
      this.investorsList.splice(index, 1);
    },
    handleSubmit() {
      const self = this;
      self.showSpinner = true;
      self.showSubmitButton = false;

      console.log(this.checkedData);

      let investors = [];

      this.checkedData.forEach((item) => {
        investors.push({
          id: item.account || null,
          email: item.email,
          firstName: item.firstName,
          lastName: item.lastName,
          name: item.name,
          isFiifiUser: !!item.isFiifiUser,
        });
      });

      let data;
      try {
        data = JSON.parse(atob(this.$route.query.d));
      } catch (e) {
        console.log("json.parse error: ", e);
        self.showThankYou();
        return;
      }

      let url = "/portfolio/investors/confirm";

      api
        .post(url, {
          encrypt: {
            data: {
              founderEmail: data.founderEmail,
              portfolio_item: this.$route.query.p,
              companyName: data.companyName,
              investors,
            },
          },
        })
        .then((data) => {
          self.showThankYou();
        })
        .catch((error) => {
          console.log("error in handleSubmit", error);
          self.showSpinner = false;
          self.showSubmitButton = true;
        });
    },

    showThankYou() {
      this.isShowThankYou = true;
      this.isShowInfo = false;
    },
  },
  mounted() {
    const titleEl = document.querySelector("head title");
    titleEl.textContent = `Fiifi | Investors`;
    if (this.$route.query.p) {
      this.getInvestors();
    }
  },
};
</script>
<style>
.investorPublicNavLayout {
  background-color: #593bfd;
  height: 58px;
}
.investorPublicFiifiLayout {
  opacity: 1;
  font-family: Comfortaa, cursive;
  font-size: 30px;
  text-transform: none;
  color: #fff;
}
.investorPublicCardLayout {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  border-radius: 5px;
  opacity: 1;
}
</style>